import { render, staticRenderFns } from "./retencao.vue?vue&type=template&id=3e40559e&scoped=true&"
import script from "./retencao.vue?vue&type=script&lang=js&"
export * from "./retencao.vue?vue&type=script&lang=js&"
import style0 from "./retencao.vue?vue&type=style&index=0&id=3e40559e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e40559e",
  null
  
)

export default component.exports